<script setup lang="ts">
/**
 * Style 03 / 04 Heels (3185:16351, 3185:16394; mobile 3183:17727, 3183:17770).
 * How often — Toggle Items; How high — Chips, shown for any answer except Never (R94).
 * Never counts as answered.
 */
import { useI18n } from 'vue-i18n'
import { useFairCompact } from '@/composables/useFairCompact'
import { FairChip } from '@/ui/primitives/FairChip'
import { FairToggleItem } from '@/ui/primitives/FairToggleItem'
import {
  STYLE_QUIZ_HEEL_FREQUENCIES,
  STYLE_QUIZ_HEEL_HEIGHTS,
  type StyleQuizHeelFrequency,
  type StyleQuizHeelHeight,
} from '../style-quiz.data'

defineProps<{
  frequency: StyleQuizHeelFrequency | null
  height: StyleQuizHeelHeight | null
}>()

const emit = defineEmits<{
  'update:frequency': [value: StyleQuizHeelFrequency]
  'update:height': [value: StyleQuizHeelHeight]
}>()

const { t } = useI18n()
const compact = useFairCompact()
</script>

<template>
  <div class="style-quiz-heels">
    <div
      class="style-quiz-heels__group"
      role="radiogroup"
      :aria-label="t('style_quiz.heels.how_often')"
    >
      <p class="style-quiz-heels__label">
        {{ t('style_quiz.heels.how_often') }}
      </p>
      <div class="style-quiz-heels__row">
        <FairToggleItem
          v-for="option in STYLE_QUIZ_HEEL_FREQUENCIES"
          :key="option"
          :label="t(`style_quiz.heels.frequency.${option}`)"
          :selected="frequency === option"
          @click="emit('update:frequency', option)"
        />
      </div>
    </div>

    <div
      v-if="frequency && frequency !== 'never'"
      class="style-quiz-heels__group"
    >
      <p class="style-quiz-heels__label">
        {{ t('style_quiz.heels.how_high') }}
      </p>
      <div class="style-quiz-heels__row">
        <FairChip
          v-for="option in STYLE_QUIZ_HEEL_HEIGHTS"
          :key="option"
          :label="t(`style_quiz.heels.height.${option}`)"
          :active="height === option"
          :size="compact ? 'mobile' : 'default'"
          @click="emit('update:height', option)"
        />
      </div>
    </div>
  </div>
</template>
